import { Routes } from '@angular/router';
import { RootComponent } from '@/app/root.component';
import { AuthGuard } from '@/app/core/guards/autenticated.guard';
import { IsAdminGuard } from '@/app/core/guards/amin-route.guard';
import { LoginComponent } from '@/app/features/auth/pages/login/login';
import { RegisterComponent } from '@/app/features/auth/pages/register/register';
import { ResetPassword } from '@/app/features/auth/pages/reset-password/reset-password';
import { MessageSucces } from '@/app/features/auth/pages/message-succes/message-succes';
import { InicioComponent } from '@/app/features/inicio/inicio-component/inicio-component';
import { ActionTokenComponent } from '@/app/features/auth/pages/action-token/action-token';
import { AyudaComponent } from '@/app/features/ayuda/pages/ayuda-component/ayuda-component';
import { Guia1ReportComponent } from '@/app/features/reportes/pages/guia1-report/guia1-report';
import { Guia2ReportComponent } from '@/app/features/reportes/pages/guia2-report/guia2-report';
import { Guia3ReportComponent } from '@/app/features/reportes/pages/guia3-report/guia3-report';
import { Guia1Component } from '@/app/features/Resultados/pages/guia1-component/guia1-component';
import { Guia2Component } from '@/app/features/Resultados/pages/guia2-component/guia2-component';
import { Guia3Component } from '@/app/features/Resultados/pages/guia3-component/guia3-component';
import { ReportesComponent } from '@/app/features/reportes/reportes-component/reportes-component';
import { ContactoComponent } from '@/app/features/ayuda/pages/contacto-component/contacto-component';
import { PoliticaComponent } from '@/app/features/ayuda/pages/politica-component/politica-component';
import { CreateNewPassword } from '@/app/features/auth/pages/create-new-password/create-new-password';
import { OcupacionComponent } from '@/app/features/ocupaciones/ocupacion-component/ocupacion-component';
import { CampanasComponent } from '@/app/features/campañas/pages/campañas-component/campanas-component';
import { UsuariosComponent } from '@/app/features/usuarios/pages/usuarios-component/usuarios-component';
import { ClientesComponent } from '@/app/features/clientes/pages/clientes-component/clientes-component';
import { CampanaComponent } from '@/app/features/campaña/components/campana-component/campana-component';
import { ResultadosComponent } from '@/app/features/Resultados/pages/resultados-component/resultados-component';
import { UsuarioFormComponent } from '@/app/features/usuarios/pages/usuario-form-component/usuario-form-component';
import { DepartamentoComponent } from '@/app/features/departamentos/departamento-component/departamento-component';
import { CampanasFormComponent } from '@/app/features/campañas/pages/campañas-form-component/campanas-form-component';
import { EditUsuariosComponent } from '@/app/features/usuarios/pages/edit-usuarios-component/edit-usuarios-component';
import { ClientesFormComponent } from '@/app/features/clientes/pages/clientes-form-component/clientes-form-component';


export const routes: Routes = [

  { path: '', component: RootComponent },
  { path: 'iniciar', component: LoginComponent },
  { path: 'registrar', component: RegisterComponent },
  { path: 'reset-password', component: ResetPassword},
  { path: 'new-password', component: CreateNewPassword},
  { path: 'message', component: MessageSucces},
  { path: 'inicio', component: InicioComponent },
  { path: 'action-token', component: ActionTokenComponent},

  // menu de usuarios
  { path: 'usuarios', component: UsuariosComponent, canActivate: [AuthGuard]},
  { path: 'usuarios/crear', component: UsuarioFormComponent, canActivate: [AuthGuard], data: {  title: 'Crear usuario' } },
  { path: 'usuarios/editar/:id', component: UsuarioFormComponent, canActivate: [AuthGuard], data: { title: 'Editar usuario' }},
  { path: 'usuarios/editar', component: EditUsuariosComponent},

  // menu de clientes
  { path: 'clientes', component: ClientesComponent, canActivate: [AuthGuard, IsAdminGuard]},
  { path: 'clientes/crear', component: ClientesFormComponent, canActivate: [AuthGuard, IsAdminGuard]},
  { path: 'clientes/editar/:id', component: ClientesFormComponent, canActivate: [AuthGuard, IsAdminGuard]},

  // menu ocupacion
  { path: 'clientes/ocupacion', component: OcupacionComponent, canActivate: [AuthGuard, IsAdminGuard]},

  // menu departamento
  { path: 'clientes/departamento', component: DepartamentoComponent, canActivate: [AuthGuard, IsAdminGuard]},

  // menu de campañas
  { path: 'clientes/campañas', component: CampanasComponent, canActivate: [AuthGuard, IsAdminGuard]},
  { path: 'clientes/campañas/crear', component: CampanasFormComponent, canActivate: [AuthGuard, IsAdminGuard], data: { title: 'Crear campaña' }},
  { path: 'clientes/campañas/editar', component: CampanasFormComponent, canActivate: [AuthGuard, IsAdminGuard], data: {title: 'Editar campaña' }},
  { path: 'clientes/campañas/ver-tokens', component: CampanasFormComponent, canActivate: [AuthGuard, IsAdminGuard], data:{view: 'tokens'}},

  // menu de ayuda
  { path: 'ayuda', component: AyudaComponent, canActivate: [AuthGuard]},
  { path: 'ayuda/politica', component: PoliticaComponent, canActivate: [AuthGuard]},
  { path: 'ayuda/contactanos', component: ContactoComponent, canActivate: [AuthGuard]},
  // vista de usuarios
  { path: 'campaña', component: CampanaComponent, canActivate: [AuthGuard], data: { roles: ['USER'] }},
  { path: 'resultados', component: ResultadosComponent, canActivate: [AuthGuard], data: { roles: ['USER', 'ADMIN' ] }},
  { path: 'resultados/guia1', component: Guia1Component, canActivate: [AuthGuard], data: { roles: ['USER', 'ADMIN'] }},
  { path: 'resultados/guia2', component: Guia2Component, canActivate: [AuthGuard], data: { roles: ['USER', 'ADMIN'] }},
  { path: 'resultados/guia3', component: Guia3Component, canActivate: [AuthGuard] , data: { roles: ['USER', 'ADMIN'] }},
  {
    path: 'reportes',
    component: ReportesComponent, canActivate: [AuthGuard], data: { roles: ['USER', 'ADMIN'] },
    children: [
      { path: '', redirectTo: 'guia-1', pathMatch: 'full' },
      { path: 'guia-1', component: Guia1ReportComponent },
      { path: 'guia-2', component: Guia2ReportComponent },
      { path: 'guia-3', component: Guia3ReportComponent },
    ],
  },


];
